import { Injectable } from '@angular/core';
import { Role } from 'src/app/features/requets/shared/model/Role.model';
import { RoleInformation } from './role-information.model';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class UtilityService {

  rolUnidadAcademica: String = 'maresASISTRECONUNIDACAD';
  rolAistenciaIdiomas: String = 'maresASISTRECONIDIOMAS';
  rolVicedecano: String = 'maresVicedecano';
  rolJefeDepto: String = 'maresJefeDeptoAcad';
  rolCoordinador: String = 'maresCOORIDIOMASRECON';

  constructor() { }

  addQueryParam(uri: any, parameters: any) {
    let newUri = uri;
    if (Object.keys(parameters).length !== 0 ) {
      newUri = newUri + '?';
      for (const clave in parameters) {
        if (parameters.hasOwnProperty(clave) && parameters[clave] !== null) {
          newUri = newUri + clave + '=' + parameters[clave];
          newUri = newUri + '&';
        }
      }
      newUri = newUri.substring(0, newUri.length - 1);
    }
    return newUri;
  }

  getCurrentPeriodoAvaible(): String {
    const currentYear = (new Date()).getFullYear();
    const currentMonth = (new Date()).getMonth();
    let periodAvaible ;

    if (currentMonth >= 6) {
      periodAvaible = currentYear + '-' + 2;
    } else {
      periodAvaible = (currentYear - 1) + '-' +  1;
    }
    return periodAvaible;
  }

  getNextPeriodoAvaible(): String {
    const currentYear = (new Date()).getFullYear();
    const currentMonth = (new Date()).getMonth();
    let periodAvaible ;

    if (currentMonth >= 6) {
      periodAvaible = (currentYear) + '-' + 2;
    } else {
      periodAvaible = currentYear + '-' +  1;
    }
    return periodAvaible;
  }

   generatePeriodPast(): String[]  {
    const periods: String[] = [];
    const currentYear = (new Date()).getFullYear();
    const currentMonth = (new Date()).getMonth();
    if (currentMonth >= 6) {
      periods.push(this.getCurrentPeriodoAvaible());
    }

    for (let i = currentYear - 1; i >= (currentYear - 50 ); i--) {
      periods.push(i + '-1');
      periods.push(i + '-2');
    }
    return periods;
  }

  generatePeriod() {
    const periods: String[] = [];
    const currentYear = (new Date()).getFullYear();
    const currentMonth = (new Date()).getMonth();

    for (let i = currentYear - 5; i <  (currentYear + 5 ); i++) {
      periods.push(i + '-1');
      periods.push(i + '-2');

    }
    return periods;
  }

  validateRole(roles , ventanaVaidacion) {
    let roleInformation = new RoleInformation();
    switch (ventanaVaidacion) {
      case 1:
          roleInformation =  this.validateRolAsistencial(roles);
          break;
      case 2:
      roleInformation =  this.validateRolCoordinadoJefe(roles);
          break;
      default:
     }
      return roleInformation;
  }

  private validateRolCoordinadoJefe (roles) {
    const roleInformation = new RoleInformation();
    roleInformation.tipoValidation = 0;
    roleInformation.roles = roles.filter( (rol: Role) =>  {
      if (rol.rol === this.rolVicedecano || rol.rol === this.rolJefeDepto || rol.rol === this.rolCoordinador) {
        return rol;
      }
    });
    if (roleInformation.roles.length > 0) {
      roleInformation.tipoValidation = 1;
      roleInformation.currentRol = roleInformation.roles[0];
      if (roleInformation.currentRol.rol === this.rolCoordinador) {
        roleInformation.tipoValidation = 2;
      }
    }
    return roleInformation;
  }


  private validateRolAsistencial(roles) {
    const roleInformation = new RoleInformation();
    roleInformation.tipoValidation = 0;
    roleInformation.roles = roles.filter( (rol: Role) =>  {
      if (rol.rol === this.rolUnidadAcademica || rol.rol === this.rolAistenciaIdiomas) {
        return rol;
      }
    });
    if (roleInformation.roles.length > 1) {
      const rolAsisIdiomas = roleInformation.roles.filter( (rol: Role) =>  {
        if (rol.rol === this.rolAistenciaIdiomas ) {
          return rol;
        }
       });
       roleInformation.currentRol = rolAsisIdiomas[0];
       roleInformation.tipoValidation = 2;
   } else {
      if (roleInformation.roles.length === 1) {
        roleInformation.tipoValidation = 1;
        roleInformation.currentRol = roleInformation.roles[0];
        if (roleInformation.currentRol.rol === this.rolAistenciaIdiomas) {
          roleInformation.tipoValidation = 2;
        }
      } else {
        roleInformation.tipoValidation = 0;
      }
   }
    return roleInformation;
  }

  generateExcel(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {type: EXCEL_TYPE});
    FileSaver.saveAs(data, fileName + '_export_' + new  Date().getTime() + EXCEL_EXTENSION);
 }

}
